import { Refresh } from "@mui/icons-material"
import { Box, Button, Grid, Typography } from "@mui/material"

const GraphDisconnectedBackdrop = () => {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "#000000BB",
          position: "absolute",
          zIndex: 50,
        }}
      ></Box>
      <Grid
        container
        sx={{
          position: "absolute",
          display: "flex",
          inset: 0,
          zIndex: 60,
          transform: "translateY(8%)",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Grid
          container
          item
          xs="auto"
          sx={{
            borderRadius: 3,
            backgroundColor: "#d32f2f",
            px: "4em",
            py: "3em",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <Grid item>
            <Typography
              variant="body1"
              sx={{
                textAlign: "center",
                color: "common.white",
                lineHeight: 1.5,
              }}
            >
              This session is no longer active.
              <br />
              Please refresh the page or click the button below to continue.
            </Typography>
          </Grid>

          <Grid item>
            <Button
              variant="contained"
              startIcon={<Refresh />}
              onClick={() => window.location.reload()}
            >
              RELOAD
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default GraphDisconnectedBackdrop
